export default {
    goodsAudit: {
        Ps1: '您正在删除',
        Ps2: '是否继续',
        page: {
            ProductCategory: '商品类别',
            Category: '类别',
            Approvaltime: '审核时间'
        },
        detail: {
            Pass: '通 过',
            Reject: '驳 回',
            BeforeModification: '修改前',
            ProductDetails: '商品详情审核',
            AfterModification: '修改后',
            BasicInformation: '基本信息',
            attribute: 'SKU属性',
            price: 'SKU价格',
            Details: 'SKU明细',
            material: '商品素材',
            status: '审核状态：',
            comments: '审核意见：',
            packageSku: '套餐SKU',

            description: '商品描述',
            Submitted: '提交人：',
        }
    }
};
